import { navigate, RouteComponentProps, useLocation } from '@reach/router'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Brand } from '.'
import { Content } from './Content'
import { Header } from './Header'
import { Menu, MenuItem, MobileMenu } from '../Menu'
import { UserAvatar } from './UserAvatar'
import { ENV } from '../../common/env'
import { ROOT_PATH, USER_SESSION_EKY } from '../../common/config'
import { Modal } from 'antd'
import IconLogout from '../../assets/menu/logout.png'
import { MenuOutlined } from '@ant-design/icons'
import { lockBody } from '../../common/helper'

const StyledDashboard = styled.div`
  width: 100vw;
  height: calc(var(--vh) * 100);
  display: flex;
  flex-direction: column;
  align-items: center;

  .right {
    display: flex;
    height: 100%;
  }
  .menu-icon {
    padding-right: 0;
  }

  @media (max-width: 600px) {
    .ant-row.ant-form-item {
      flex-direction: row;
    }
  }
`

export const Dashboard: React.FC<RouteComponentProps> = (props) => {
  const userInfo = JSON.parse(sessionStorage.getItem(USER_SESSION_EKY) || '{}')
  const [menuVisible, setMenuVisible] = useState(false)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [location.pathname])

  useEffect(() => {
    lockBody(menuVisible)
  }, [menuVisible])

  if (!ENV.hasLogined) {
    window.location.replace('/')
    return null
  }

  const logout = () => {
    Modal.confirm({
      className: 'logout-modal',
      icon: null,
      content: (
        <div className="text-center">
          <Brand className="mx-auto" />
          <div className="text-lg font-bold">
            <h1>Leaving</h1>
            <h1>SHENMA Credit?</h1>
          </div>
        </div>
      ),
      okText: 'YES, Log Out',
      cancelText: 'NO',
      cancelButtonProps: {
        danger: true,
        type: 'primary',
        className: 'w-28',
      },
      onOk() {
        sessionStorage.clear()
        navigate(ROOT_PATH)
      },
    })
  }
  return (
    <StyledDashboard>
      <Header noShadow={menuVisible}>
        <Brand />
        <div className="right">
          <div className="hidden lg:block">
            <Menu />
          </div>
          <div className="hidden lg:block">
            <UserAvatar src={userInfo.avatar} name={userInfo.name} time={userInfo.lastLogonTime} />
          </div>
          <div className="hidden lg:block">
            <MenuItem onClick={logout}>
              <img className="w-6 mr-2" src={IconLogout} alt="profile" />
              <span>Logout</span>
            </MenuItem>
          </div>
          <div className="block lg:hidden">
            <MenuItem className="menu-icon" onClick={() => setMenuVisible(!menuVisible)}>
              <MenuOutlined />
            </MenuItem>
          </div>
        </div>
      </Header>
      {menuVisible && <MobileMenu hideMenu={() => setMenuVisible(false)} onLogout={logout} />}
      <Content>{props.children}</Content>
    </StyledDashboard>
  )
}
